import { render, staticRenderFns } from "./control.vue?vue&type=template&id=7f663afc&scoped=true&"
import script from "./control.vue?vue&type=script&lang=ts&"
export * from "./control.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f663afc",
  null
  
)

export default component.exports